<template>
  <div id="app">
    <router-view />
    <toasts />
  </div>
</template>

<script>
import { getGameId, Cookie } from './common'
import toasts from './components/toasts'
export default {
  data () {
    return {}
  },
  methods: {
    updateWindowFontSize () {
      const docEl = document.documentElement
      window.fontSize = document.body.clientWidth / 10
      docEl.style.fontSize = window.fontSize + 'px'

      let realitySize = window.getComputedStyle(docEl).fontSize
      realitySize = parseFloat(realitySize)
      if (Math.abs(realitySize - window.fontSize) > .3) {
        console.log('not match', window.getComputedStyle(docEl).fontSize, window.fontSize)
        window.fontSize = window.fontSize * window.fontSize / realitySize
        docEl.style.fontSize = window.fontSize + 'px'
      }
    }
  },
  mounted(){
    this.updateWindowFontSize()
    window.addEventListener('resize', this.updateWindowFontSize, true)
    window.addEventListener('orientationchange', this.updateWindowFontSize, true)
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.updateWindowFontSize)
    window.removeEventListener('orientationchange', this.updateWindowFontSize)
  },
  created(){
    // if(getGameId() === 'ma78'){
    //   Cookie.set('channel', null, { expires: 365 })
    // }
  },
  components: {
    "toasts": toasts,
  }
}
</script>

<style lang="scss">
  @import 'common/common';
</style>

<style lang="scss" scoped>
  #app{
    flex: 1;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue